import { IconButton, Close16, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import { TRANSPORT_ACCESSIBILITY_SIDEBAR_WIDTH } from 'shared/constants/transportAccessibilityInfrastructure';

import * as styles from './TransportAccessibilitySidebar.css';
import { TransportDepartmentIcon, TransportDepartmentInfo } from './parts';
import { InfoPlate } from '..';

export interface ITransportAccessibilitySidebarProps {
  onClose: () => void;
  tabs: React.ReactNode;
}

export const TransportAccessibilitySidebar: React.FC<ITransportAccessibilitySidebarProps> = ({
  children,
  onClose,
  tabs,
}) => {
  return (
    <div className={styles['container']} style={{ width: `${TRANSPORT_ACCESSIBILITY_SIDEBAR_WIDTH}px` }}>
      <div className={styles['close-button']}>
        <IconButton icon={<Close16 />} onClick={onClose} />
      </div>
      <div className={styles['header']}>
        <UIHeading2>Транспортная доступность</UIHeading2>
      </div>
      {tabs && (
        <div className={styles['tabs-wrapper']} data-testid="TransportAccessibilityTabs">
          {tabs}
        </div>
      )}
      <div className={styles['content-wrapper']}>
        {children}
        <div className={styles['data-from']}>
          <InfoPlate icon={<TransportDepartmentIcon />} content={<TransportDepartmentInfo />} withHorizontalMargin />
        </div>
      </div>
    </div>
  );
};
